<script>

import gsap from "gsap"
import SimplexNoise from "simplex-noise"
import { BUBBLE_VERTEX_SHADER, BUBBLE_FRAGMENT_SHADER } from "../js/constant.js"
import { Color, Vector3 } from "three"

export default {

  name: 'Ring',
  render: h => h(),
  props:['specs'],
  mounted() {
    this.init()
  },

  methods: {

    init() {
  
      let scene = this.$parent.scene
      let geometry = new THREE.RingBufferGeometry( 10, 12, 128 )
      const material = new THREE.ShaderMaterial( {
        wireframe: true,
        uniforms: {
          color1: { value: new Color(this.specs.c1) },
          color2: { value: new Color(this.specs.c2) }
        },
        vertexShader: BUBBLE_VERTEX_SHADER,
        fragmentShader: BUBBLE_FRAGMENT_SHADER

      } )

      this.simplex = new SimplexNoise() 
      this.mesh = new THREE.Mesh(geometry, material)
      this.mesh.geometry.attributes.position.needsUpdate = true
      scene.add(this.mesh)
    },

    update(time, spikes, _analyser, _duration ){
      const analyser = _analyser ? _analyser : 0
      const duration = _duration ? _duration : 0
      const positions = this.mesh.geometry.attributes.position
      const vertex = new Vector3()
      for (let i = 0; i < positions.count; i++) {
        const b = vertex.fromBufferAttribute(positions, i)
        vertex.normalize()
          .multiplyScalar(
          this.specs.size +
              (analyser + duration + .25) *
                this.simplex.noise4D(
                  b.x * spikes + time,
                  b.y * spikes + time,
                  b.z * spikes,
                  0
                )
          )
        positions.setXYZ(i, vertex.x, vertex.y, vertex.z)
      }
      positions.needsUpdate = true
    }
  }

}
</script>


